import * as yup from "yup";

/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";

import Autocomplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TextField from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceMotivoLancamento from "../../../../services/serviceMotivoLancamentoManual";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data: { open: boolean; id: string; tipoLancamentoManual: string; tituloLancamentoManual: string };
}

export default function DialogEdit({ open, onClose, data, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        tipoLancamentoManual: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        tituloLancamentoManual: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            tipoLancamentoManual: "",
            tituloLancamentoManual: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const option = [
        { value: "Dedução", label: "Dedução" },
        { value: "Acréscimo", label: "Acréscimo" },
    ];

    const onSubmit = (values: any) => {
        setDisable(true);

        const updateValues = {
            ...values,
            motivoLancamentoManualID: data.id,
        };

        serviceMotivoLancamento
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Editar Motivo de Lançamento Manual
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Box>
                            <Autocomplete
                                name="tipoLancamentoManual"
                                label="Categoria"
                                control={control}
                                error={errors}
                                options={option}
                            />

                            <TextField name="tituloLancamentoManual" label="Titulo" control={control} error={errors} />
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
